import { classNames } from "classnames";
import { fmtMsg } from "./../../../../commonui/utils/func";
import { Vue, Component, Watch } from "vue-property-decorator";
import { ApplicationViews } from "@/util/enum";
import { Column, Table } from "ant-design-vue/lib";
import { ReportsLocale } from '@/locales/localeid';
import { ReportsModule } from '@/modules/reports-objective';
import { VersionGroupModule } from '@/modules/versiongroup';

@Component({
	components: {
		Table
	}
})
export default class VPCOverview extends Vue {
	public view = ApplicationViews.VpcOverview;
	public columns: Column[] = [];

	private vpcColumn: Column[] = [
		{
			title: fmtMsg(ReportsLocale.ReportsVPCText),
			width: 180,
			dataIndex: "title"
		},
		{
			title: fmtMsg(ReportsLocale.ReportsVPCReviewText),
			width: 60,
			dataIndex: "review"
		},
		{
			title: fmtMsg(ReportsLocale.ReportsTotalText),
			width: 60,
			dataIndex: "totalCount",
			className: "total-column"
		}
	];

	private extraColumn: Column = {
		width: 30,
		dataIndex: "lesson",
		scopedSlots: { customRender: "title" }
	};

	get formatedVpcs() {
		return ReportsModule.formatedVpcs;
	}

	get vpcs() {
		return ReportsModule.vpcs;
	}

	get lessonPlanSimples() {
		return ReportsModule.lessonPlanSimples;
	}

	get relatedVpcCounts() {
		return ReportsModule.relatedVpcCounts;
	}

	get versionGroupId() {
		return VersionGroupModule.selectedGsVersion !== "-1"
			? VersionGroupModule.selectedGsVersion
			: VersionGroupModule.selectedLsVersion;;
	}

	get vcsLevelId() {
		return ReportsModule.selectedUnit.id;
	}

	get loading() {
		return ReportsModule.isLoading;
	}

	getLessonPlanColumn(lessonplan, sequence): Column {
		const { id } = lessonplan;
		return {
			width: 30,
			key: id,
			title: sequence,
			dataIndex: id,
			className: "lessonplan-column"
		};
	}

	clearColumns() {
		this.columns = [];
		this.columns = this.columns.concat(this.vpcColumn);
	}

	@Watch("lessonPlanSimples")
	formatColumns() {
		this.clearColumns();
		this.lessonPlanSimples.forEach((lessonplan, index) => {
			this.columns.push(this.getLessonPlanColumn(lessonplan, index + 1));
		});
	}
}
